/** @format */

import axios from 'axios';
import { GlobalVendor, VendorFormInput, VendorFilterInput } from '../types';

const apiUrl = process.env.REACT_APP_SIADASH_BACKEND_URL;

/**
 * Get all global vendors
 */
export const getAllVendors = async (filter?: VendorFilterInput): Promise<GlobalVendor[]> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${apiUrl}/api/global-vendors`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: filter,
  });
  return response.data;
};

/**
 * Get vendor by ID
 */
export const getVendorById = async (id: string): Promise<GlobalVendor> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${apiUrl}/global-vendors/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/**
 * Get vendor by name
 */
export const getVendorByName = async (name: string): Promise<GlobalVendor> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${apiUrl}/global-vendors/name/${encodeURIComponent(name)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/**
 * Create a single vendor
 */
export const createVendor = async (vendor: VendorFormInput): Promise<GlobalVendor> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.post(`${apiUrl}/api/global-vendors`, vendor, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

/**
 * Create multiple vendors in batch
 */
export const batchCreateVendors = async (vendors: VendorFormInput[]): Promise<GlobalVendor[]> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.post(`${apiUrl}/api/global-vendors/batch`, vendors, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

/**
 * Update a vendor
 */
export const updateVendor = async (id: string, vendor: VendorFormInput): Promise<GlobalVendor> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.put(`${apiUrl}/global-vendors/${id}`, vendor, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

/**
 * Delete a vendor
 */
export const deleteVendor = async (id: string): Promise<GlobalVendor> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.delete(`${apiUrl}/global-vendors/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
